<meta name="viewport" content="width=device-width, initial-scale=1.0"/>

<div
  data-qa="sent-link-container"
  class="flex flex-col items-center justify-center resize-index mobile:text-[3.75rem] h-screen">
  <div class="z-[2] white-card-no-padding w-[35em] min-h-[28.75em] flex items-center justify-center mobile:w-[100%] mobile:h-[100%] p-[1.25em]">
    <div class="gap-[1.25em] flex flex-col min-h-[26.25em] w-[19.5125em] justify-center items-center mobile:p-[1.25em] mobile:w-full">
      <div data-qa="sent-link-logo-container" id="logo" class="w-[12.5em] h-[6.25em] flex items-center justify-center">
        <app-all-icons
          data-qa="sent-link-icon"
          [iconNameAndStyling]="'empty-exclamation.svg;icon-size-5;main-8'"/>
      </div>
      <div class="flex flex-col items-center justify-center gap-[0.625em]">
        <span data-qa="title" class="text-[1.328125em] bold600">Access restricted</span>
        <span data-qa="subtitle" class="text-[0.75em] black-10">
          Our logs noticed out-of-pattern activity.<br>
          Please contact your organization admin.
        </span>
      </div>
      <div class="border-bottom w-full"></div>
      <div class="flex flex-col items-center justify-center">
        <span>Need help? Contact us at</span>
        <a data-qa="support-email" class="main-8" [href]="'mailto:' + supportEmail">{{ supportEmail }}</a>
      </div>
    </div>
  </div>
  <div
    data-qa="bottom-logos"
    class="absolute mb-[1.25em] bottom-0 w-full flex flex-col items-center justify-center mobile:z-3">
    <app-all-icons
      class="translate-y-[1em]"
      href="https://www.orcainc.com/"
      [iconNameAndStyling]="'orca-logo-no-servc.svg;icon-size-3'"
    />
    <span id="bottom-text" class="black-12 text-[0.75em]">
      Powered by <a href="https://www.servc.co.il/financial-services" class="underline">SerVC</a>
    </span>
  </div>
</div>
